<template>
	<svg
		width="9"
		height="5"
		viewBox="0 0 9 5"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M4.5 0L8.83013 4.5H0.169873L4.5 0Z"
			fill="currentColor"
		/>
	</svg>
</template>
